module.exports = __webpack_public_path__ + "images/category_lp/common/icon-zero-yen@2x_bfe2dbfa1c45e970e64868ed1313442b.png";